import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { hmenu, smenu, hmenu_master_arr, get_hmenu_arr, get_now_smenu } from "@/pcomponents/comp/layout/menu/data/menu_arr";

const GNBArea = (props: any) => {
  let myProps = {
    site_map_btn: null,
    ...props
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let user = useSelector((state: any) => state.user);

  const movePage = (url: string) => {
    navigate(url);
  };

  let comp_sort_detail = user.comp_sort_detail;
  if (location.hostname == "dalirant.planiedu.com") {
    comp_sort_detail = "dalirant";
  }

  let now_h_key = "";
  let now_smenu = get_now_smenu({
    "user_grade": user.user_grade,
    "comp_sort_detail": comp_sort_detail,
    user: user,
  });
  if (now_smenu) {
    now_h_key = now_smenu.hmenu;
  }


  let menuArr = get_hmenu_arr({
    "user_grade": user.user_grade,
    "comp_sort_detail": comp_sort_detail,
    "is_main":user.comp_seq=="4",
    user: user,
  });

  const menuArrTags = menuArr.map((item: any, idx: number) => {
    let gnb_class_name = "gnb_item";
    if (item.isShow == false) {
      return "";
    }
    if (item.key == now_h_key) {
      gnb_class_name += " active";
    }

    return (
      <div key={idx} className={gnb_class_name} onClick={() => { movePage(item.url); }} >
        {(item.ico && item.ico_active) &&
          <img src={(item.key == now_h_key) ? item.ico_active : item.ico} className="gnb_item_ico" />
        }
        {item.name}
      </div>
    );
  });

  return (
    <div className="gnb_area">
      {myProps.site_map_btn && (
        <div className="gnb_item" >
          {myProps.site_map_btn}
        </div>
      )}
      {menuArrTags}
    </div>
  );
};

export default GNBArea;